import { Link, Navigate } from '@tanstack/react-router'
import { ProductMark } from '@/components/shell/Sidebar'
import { Button } from '@/components/ui/Controls'
import { useAuth } from '@/features/auth/useAuth'

import { HomeHero } from '@/components/home/HomeHero'
import { TrustStrip } from '@/components/home/TrustStrip'
import { CapabilitiesBento } from '@/components/home/CapabilitiesBento'
import { RepositoryIntelligence } from '@/components/home/RepositoryIntelligence'
import { ControlledExecution } from '@/components/home/ControlledExecution'
import { InfrastructureSection } from '@/components/home/InfrastructureSection'
import { WorkflowSection } from '@/components/home/WorkflowSection'
import { AuditabilitySection } from '@/components/home/AuditabilitySection'
import { SecuritySection } from '@/components/home/SecuritySection'
import { PricingPreview } from '@/components/home/PricingPreview'
import { FinalCTA } from '@/components/home/FinalCTA'

export function HomePage() {
  const { user, isLoading } = useAuth()

  if (isLoading) return <div className="min-h-full bg-ground" />
  if (user) return <Navigate to="/chat" replace />

  return (
    <div className="relative min-h-screen bg-ground flex flex-col font-sans">
      
      {/* Navbar */}
      <header className="fixed top-0 left-0 right-0 z-50 border-b border-line bg-surface/80 backdrop-blur-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-4 sm:px-6 text-sm">
          <Link to="/" className="flex items-center gap-2 text-ink hover:opacity-80 transition-opacity">
            <ProductMark className="h-6 w-6" />
            <span className="text-base font-semibold">RepoPilot</span>
          </Link>
          <nav className="hidden sm:flex items-center gap-6">
            <Link to="/pricing" className="text-ink-dim hover:text-ink transition-colors">
              Pricing
            </Link>
            <Link to="/signin" className="text-ink-dim hover:text-ink transition-colors">
              Sign in
            </Link>
            <Link to="/signin">
               <Button variant="primary" className="py-1.5 px-4 shadow-sm">Start free</Button>
            </Link>
          </nav>
          <nav className="sm:hidden flex items-center gap-4">
            <Link to="/signin" className="text-ink-dim hover:text-ink transition-colors">
              Sign in
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1 flex flex-col pt-16">
        <HomeHero />
        <TrustStrip />
        <CapabilitiesBento />
        <RepositoryIntelligence />
        <ControlledExecution />
        <InfrastructureSection />
        <WorkflowSection />
        <AuditabilitySection />
        <SecuritySection />
        <PricingPreview />
        <FinalCTA />
      </main>

      {/* Footer */}
      <footer className="relative z-20 border-t border-line bg-surface">
        <div className="mx-auto flex max-w-7xl flex-col sm:flex-row items-center justify-between gap-4 px-4 py-8 text-xs text-ink-muted sm:px-6">
          <div className="flex items-center gap-2">
            <ProductMark className="h-4 w-4 opacity-50" />
            <span>&copy; {new Date().getFullYear()} RepoPilot. All rights reserved.</span>
          </div>
          <nav className="flex flex-wrap items-center gap-6">
            <Link to="/pricing" className="hover:text-ink transition-colors">
              Pricing
            </Link>
            <Link to="/privacy" className="hover:text-ink transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-ink transition-colors">
              Terms
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  )
}
